
export class HateoasCacheItem {

  private _href : string;
  private _data : any;
  private _date: Date;

  constructor(href : string, data: any) {
    this._href = href;
    this._data = data;
    this._date = new Date();
  }

  public getHref() : string {
    return this._href;
  }

  public getData() : any {
    return this._data;
  }

  public getDate() : Date {
    return this._date;
  }

}
